/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { FeeExclusionItemDto, FeeExclusionUpdateDto } from './fee-exclusions.dto';

export const FeeExclusionsListItemMapper = entity<FeeExclusionItemDto>({});
export const FeeExclusionsUpdateMapper = entity<FeeExclusionUpdateDto>({});
